// extracted by mini-css-extract-plugin
export default {"Roles":"Roles_Roles__pvLHs"};